/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/input-box/input-box');
require('components/base/checkbox/checkbox');
require('components/base/form-area/form-area');
require('components/base/drop-menu/drop-menu');
require('components/base/upload/upload')
require('components/common/drop-menu-input/drop-menu-input')
require('components/common/date-time/date-time')
require('./add-desktop-push.scss');

const tip = require('components/base/pop/tip');
const template = require('./add-desktop-push.tpl');
const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp.js');
const configPushMixin = require('../../mixin')

const { apiPath } = require('appService/api');
const {
  checkbox: checkboxEvent,
  dropMenu: dropMenuEvent
} = require('components/config/event.json');

const addDesktopPush = {
  name: "add-desktop-push",

  template,

  mixins: [configPushMixin],

  data() {
    return {
      uploadImg: apiPath.common.uploadImg,
      detailData: {},
      cityOptionUrl: apiPath.common.city,
      pushUserIdEmpty: true,
      pushUserIdTailEmpty: true,
      linkEmpty: true
    }
  },

  computed: {
    isEdit () {
      return !!this.$route.params.id
    }
  },

  events: {
    [checkboxEvent.change](opt) {
      if (opt.dispatcher.queryName === 'pushRange') {
        if (opt.value === 1) {
          this.pushUserIdEmpty = false
          this.pushUserIdTailEmpty = true
        } else if (opt.value === 2) {
          this.pushUserIdTailEmpty = false
          this.pushUserIdEmpty = true
        } else {
          this.pushUserIdTailEmpty = true
          this.pushUserIdEmpty = true
        }
      }
    },

    [dropMenuEvent.menu.change](opt) {
      if (opt.dispatcher.queryName === 'redirect') {
        if (opt.value === 2 ||opt.value === 3) {
          this.linkEmpty = false
        } else {
          this.linkEmpty = true
        }
      }

      return false;
    },
  },

  methods: {
    _init(){
      var id = this.$route.params.id

      if(id) {
        // 编辑状态
        ajaxHttp(apiPath.configPush.desktopPush.detail, {
          data: {
            id: id
          }
        }).then((rtn) => {
          this.detailData = rtn.data

          var platformVal = rtn.data.platform

          if (platformVal === 3) {
            this.detailData.platform = [1, 2]
          } else {
            this.detailData.platform = [this.detailData.platform]
          }
        }).catch((rtn) => {
          tip(rtn.message)
        })
      }
    },

    submit () {
      var $refs = this.$refs

      if (this.isEdit) {
        $refs.formArea.setAction(apiPath.configPush.desktopPush.edit).submit()
      } else {
        $refs.formArea.setAction(apiPath.configPush.desktopPush.add).submit()
      }
    },

    beforeSubmit (queryOpt, vm) {
      if (queryOpt.platform.length === 2) {
        vm.queryOpt.platform = 3;
      } else {
        vm.queryOpt.platform = queryOpt.platform[0]
      }

      if (queryOpt.pushCity.length === this.cityList.length) {
        vm.queryOpt.pushCity = [999999]
      }

      this.$refs.submit.switchBtnLoading('show')
    },

    submitSuccess (rtn) {
      const self = this

      if (rtn.code === 0) {
        tip(`${this.isEdit ? '保存' : '新增'}成功`, {
          cb() {
            self.$route.router.go({
              path: '/page/configPush/desktopPush'
            })
          }
        })
      } else {
        tip (rtn.error)
      }

      this.$refs.submit.switchBtnLoading('hide')
    }
  },

  ready(){
    this._init();
  }
}

module.exports = addDesktopPush;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/desktop-push/add-desktop-push/add-desktop-push.js